<template>
  <div>
    <nav-bar ref="navbar" v-show="!scrolled" />
    <div id="main-layout">
      <sidebar-menu
        :menu="menu"
        :collapsed="isAsideCollapsed"
        @toggle-collapse="onToggleCollapse"
        width="240px"
      >
        <span slot="toggle-icon">
          <b-icon icon="arrow-left-right" />
        </span>
        <span slot="dropdown-icon">
          <b-icon icon="menu-down" />
        </span>
      </sidebar-menu>
      <div class="workspace-layout f-1">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/layout/NavBar'
import { SidebarMenu } from 'vue-sidebar-menu'

import { subscribe } from '@/api/messaging'

export default {
  name: 'MainLayout',
  components: {
    NavBar,
    SidebarMenu
  },
  data() {
    return {
      scrolled: false,
    }
  },
  mounted() {
    this.initializeMessagingToken()

    this.$messaging.onMessage(this.onPushMessage)
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    isAlarmed() {
      return this.$store.getters['notification/isAlarmed']
    },
    isAsideCollapsed() {
      return this.$store.state.isAsideCollapsed
    },
    menu() {
      const hasPermission = this.$store.getters['auth/hasPermission']
      const allMethod = ['GET', 'POST', 'PUT', 'DELETE']
      return [
        {
          href: '/',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'desktop-mac',
              size: 'is-small'
            }
          },
          title: 'Dashboard'
        },
        {
          href: '/client',
          title: 'Client',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'domain',
              size: 'is-small'
            }
          },
          hidden: !hasPermission('CLIENT', allMethod)
        },
        {
          href: '/project',
          title: 'Project',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'office-building',
              size: 'is-small'
            }
          },
          hidden: !hasPermission('PROJECT', allMethod)
        },
        {
          href: '/gateway',
          title: 'Gateway',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'raspberry-pi',
              size: 'is-small'
            }
          },
          hidden: !hasPermission('GATEWAY', allMethod)
        },
        {
          href: '/driver',
          title: 'Panel Driver',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'video-input-component',
              size: 'is-small'
            }
          },
          hidden: !hasPermission('DRIVER', allMethod)
        },
        {
          title: 'Access Control',
          icon: {
            element: 'b-icon',
            attributes: {
              icon: 'shield-account-variant-outline',
              size: 'is-small'
            }
          },
          child: [
            {
              href: '/user',
              title: 'Users',
              icon: {
                element: 'b-icon',
                attributes: {
                  icon: 'account',
                  size: 'is-small'
                }
              },
              hidden: !hasPermission('USER', allMethod)
            },
            {
              href: '/role',
              title: 'Roles',
              icon: {
                element: 'b-icon',
                attributes: {
                  icon: 'badge-account-horizontal',
                  size: 'is-small'
                }
              },
              hidden: !hasPermission('PERMISSION', allMethod)
            },
            {
              href: '/permission',
              title: 'Permissions',
              icon: {
                element: 'b-icon',
                attributes: {
                  icon: 'shield-check',
                  size: 'is-small'
                }
              },
              hidden: !hasPermission('PERMISSION', allMethod)
            }
          ]
        }
      ]
    }
  },
  methods: {
    onPushMessage(payload) {
      const type = payload.notification.title.indexOf('TROUBLE') !== -1 ? 'is-warning' : 'is-danger'
      const icon = payload.notification.title.indexOf('TROUBLE') !== -1 ? 'fire' : 'alert'

      this.$buefy.notification.open({
        message: payload.notification.title,
        type,
        icon,
        closable: false,
        duration: 5000,
        'has-icon': true
      })
    },
    initializeMessagingToken() {
      const getToken = () => {
        this.$messaging.getToken().then((token) => {
          subscribe({ token })
        })
      }
      this.$messaging.onTokenRefresh(getToken)

      // Setup messaging token
      getToken()
    },
    onToggleCollapse(collapse) {
      this.$store.commit('asideCollapseToggle', collapse)
    },
  }
}
</script>
